module.exports = __webpack_public_path__ + "007da625a8f351ef134ef64ee768eba1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Spotin_SymbolS_Ring_Off_White_Small_RGB.png
// module id = 166
// module chunks = 0